// extracted by mini-css-extract-plugin
export default {"wrapper":"Disclaimer_style_wrapper__YEYcU","content":"Disclaimer_style_content__SyeGS","icon":"Disclaimer_style_icon__kD2Tp","rotate":"Disclaimer_style_rotate__0hKmT"};